import React from 'react'
import get from 'lodash/get'
import _ from 'lodash'
import Helmet from 'react-helmet'
import Hero from '../components/hero'
import SponsorPreview from '../components/sponsor-preview'
import styles from './index.module.css'
import docStyles from './document.module.css'
import { cdocs } from '../data/cdocs.js'

class ChurchDocumentsIndex extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')

    const posts = cdocs
    const siteData = get(this.props, 'data.site.siteMetadata')
    const siteDescription = 'YOUCAT Indonesia membantu formasio pendamping anak muda dalam pengembangan iman Katolik dengan menyediakan materi pembinaan terutama bagi para pendamping anak muda dalam mempersiapkan anak muda menjadi saksi iman di tengah masyarakat'

    return (
      <div style={{ background: '#fff' }} className="page-content">
        <Helmet title={`Dokumen Gereja | YOUCAT Indonesia`}>

          <link rel="canonical" href={`${siteData.siteUrl}/document/`} />
          <meta name="description" content={`${siteDescription}`} />
          <meta name="title" content={`Dokumen Gereja | YOUCAT Indonesia`} />

          <meta property="og:title" content={`Dokumen Gereja | YOUCAT Indonesia`} />
          <meta property="og:site_name" content="YOUCAT Indonesia" />
          <meta property="og:url" content={`${siteData.siteUrl}/document`} />
          <meta property="og:description" content={`${siteDescription}`}  />
          <meta property="og:image" content="https://static.youcat.id/ogimg/ogimg-youcat.png" />
          <meta property="og:locale" content="id_ID" />
          <meta property="og:type" content="website" />

        </Helmet>
        <h1 className="page-title">Dokumen-dokumen Gereja</h1>
        <section className="section-documents">
          <ul className="list-group">
            { _.map(posts, function(x, index ) {
              return (
                <li key={index} className={`${docStyles.docItem}`}>
                  <div className={`document-list-item grid-x align-justify align-middle`}>
                    <div className={`title cell medium-auto ${docStyles.docTitle}`}>
                      { x.tajuk.la ? (
                        <div className={`latin ${docStyles.textLatin}`}>{x.tajuk.la}</div>
                      ): '' }
                      <div className={`indonesian ${docStyles.textIndonesian}`}>{x.tajuk.id}</div>
                    </div>
                    <div className={`link cell medium-shrink align-right text-right`}>
                      <a className={`${docStyles.downloadButton}`} rel="noreferrer" href={x.linkUrl} target="_blank" title="Unduh"> Unduh </a>
                    </div>
                  </div>
                </li>
              )
            }) }
          </ul>
        </section>
      </div>
    )
  }
}

export default ChurchDocumentsIndex

export const pageQuery = graphql`
  query ChurchDocumentsQuery {
    site {
      siteMetadata {
        title
        siteUrl
        siteImg
      }
    }
  }
`







// WEBPACK FOOTER //
// ./src/pages/document.js